import { HttpService } from "@/core";
export class ExWarehouseService {
  // 领料单列表
  static useExWarehouseListApi() {
    const api = (id?: string) =>
      HttpService.axios({
        method: "POST",
        url: `/receive_material/simple/list`,
        data:{projectIds:id?[id]:null,noRelatedValidTakeOutReceipts:1}
      });
    return HttpService.useRequest<any>(api);
  }
  static useExWarehouseList() {
    const api = (data?) =>
      HttpService.axios({
        method: "POST",
        url: `/take_out/getTakeOutRelaveDetail`,
        data
      });
    return HttpService.useRequest<any>(api);
  }
}
